<template>
  <div class="navi">
    <div class="logo"></div>
    <ul>
      <li
        v-for="link in links"
        @click="handleClick(link)"
        :key="link"
        :class="linkClass(link)"
        class="link"
      ></li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: ['concept', 'business', 'company', 'contact']
    }
  },
  methods: {
    handleClick(pageName) {
      this.$store.commit('setPage', pageName)
    },
    linkClass(link) {
      const pageName = this.$store.getters.currentPage

      return {
        [`link-${link}`]: true,
        active: pageName === link
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.navi
  position: fixed
  top: 28px
  left: 28px
  z-index: 1000
  .logo
    width: 75px
    height: 60px
    background-image: url('/images/logo.svg')
    background-repeat: no-repeat
    background-position: center
  ul
    padding: 0
    margin: 0
    margin-top: 25px
  .link
    width: 68px
    height: 10px
    background-repeat: no-repeat
    background-position: left center
    background-size: contain
    margin-bottom: 10px
    list-style: none
    cursor: pointer
    @each $page in concept, business, company, contact
      &-#{$page}
        background-image: url('/images/nav-#{$page}.svg')
    &-concept
      width: 55.8px
      height: 8.35px
    &-business
      width: 63.4px
      height: 8.2px
    &-company
      width: 67.3px
      height: 7.3px
    &-contact
      width: 60.5px
      height: 8.1px
    &.active
      border-bottom: 1px solid
    a
      width: 68px
      display: inline-block
      height: 10px
      vertical-align: top
</style>
